import { render, staticRenderFns } from "./PrivacyPolicyEN.vue?vue&type=template&id=5d8fb518&"
import script from "./PrivacyPolicyEN.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyEN.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports